import { render, staticRenderFns } from "./PointCreditComplete.vue?vue&type=template&id=9c9d6850"
import script from "./PointCreditComplete.vue?vue&type=script&lang=js"
export * from "./PointCreditComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports